import { createContext, useContext, useState,useEffect } from "react";
import {Api} from "./api";
import { useToast } from './ToastContext'; 



const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const initialCart = JSON.parse(localStorage.getItem("cart")) || [];
    
    const [cart, setCart] = useState(initialCart);
    const [cartLoading, setCartLoading] = useState(false);
    const [loadingProductId, setLoadingProductId] = useState(false);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const {showMessage,showLoading } = useToast();
    const {location,setlocation} = useState(false);

    const fetchCartFromApi = async () => {
        setLoadingProductId(true);
        try {
            const response = await Api("cart");
            if(response && response.success==true){
                setCart(response.psdata); // ذخیره اطلاعات در state
                localStorage.setItem("cart", JSON.stringify(response.psdata)); // ذخیره اطلاعات در localStorage
            }
        } catch (error) {
            console.error("Error fetching cart data:", error);
        } finally {
           
            setLoadingProductId(false); // پایان بارگذاری
        }
    };
    const handleRemoveFromCart = async (product) => {
        setLoadingProductId(product.id_product); 
       
   
        const loadingToastId = showLoading("در حال انجام عملیات...");
        
        try{
            const response = await Api("cart", { id_product: product.id_product,id_product_attribute:product.id_product_attribute, delete: true });
            if(response && response.success==true){
                setIsCartOpen(true);
                
                setCart(response.psdata); // ذخیره اطلاعات در state
                localStorage.setItem("cart", JSON.stringify(response.psdata)); // ذخیره اطلاعات در localStorage
                if (response && response.psdata.errors && Array.isArray(response.psdata.errors) && response.psdata.errors.length > 0) {
                    response.psdata.errors.map((index,error)=>{
                        
                        showMessage('error',`خطا ${index + 1}: ${error}`, 3000, loadingToastId);
                    });
                }
                else{
                    
                    
                    showMessage('success', "عملیات موفقیت‌آمیز بود!", 3000, loadingToastId);
                }
            }
           
        } catch (error) {
            console.error("API Error:", error);
           
           
        } finally {
           
            setLoadingProductId(false); // پایان بارگذاری
        }
    }
    const handleDeleteFromCart = async (product) => {
        setLoadingProductId(product.id_product); 
       
    
        const loadingToastId = showLoading("در حال انجام عملیات...");
        
        try{
            const response = await Api("cart", { id_product: product.id_product,id_product_attribute:product.id_product_attribute, op: 'down' });
            if(response && response.success==true){
                setIsCartOpen(true);
                
                setCart(response.psdata); // ذخیره اطلاعات در state
                localStorage.setItem("cart", JSON.stringify(response.psdata)); // ذخیره اطلاعات در localStorage
                if (response && response.psdata.errors && Array.isArray(response.psdata.errors) && response.psdata.errors.length > 0) {
                    response.psdata.errors.map((index,error)=>{
                        
                        showMessage('error',`خطا ${index + 1}: ${error}`, 3000, loadingToastId);
                    });
                }
                else{
                    
                    
                    showMessage('success', "عملیات موفقیت‌آمیز بود!", 3000, loadingToastId);
                }
            }
           
        } catch (error) {
            console.error("API Error:", error);
           
           
        } finally {
           
            setLoadingProductId(false); // پایان بارگذاری
        }
    }
    const handleAddToCart = async (product) => {
        setLoadingProductId(product.id_product); 
       
     
        const loadingToastId = showLoading("در حال انجام عملیات...");
        
        try{
            const response = await Api("cart", 
                { 
                    id_product : product.id_product,
                    id_product_attribute : product.id_product_attribute,
                    loc_code : product.loc_code, 
                    update : true 
                }
            );
            if(response && response.success==true){
                setIsCartOpen(true);
               
                setCart(response.psdata); // ذخیره اطلاعات در state
                localStorage.setItem("cart", JSON.stringify(response.psdata)); // ذخیره اطلاعات در localStorage
                if (response && response.psdata.errors && Array.isArray(response.psdata.errors) && response.psdata.errors.length > 0) {
                    response.psdata.errors.map((index,error)=>{
                        
                        showMessage('error',`خطا ${index + 1}: ${error}`, 3000, loadingToastId);
                    });
                }
                else{
                    
                    
                    showMessage('success', "عملیات موفقیت‌آمیز بود!", 3000, loadingToastId);
                }
            }
           
        } catch (error) {
            console.error("API Error:", error);
           
           
        } finally {
           
            setLoadingProductId(false); // پایان بارگذاری
        }
    };
    
    useEffect(() => {
        fetchCartFromApi();
    }, []);

    const toggleCart = () => {
        setIsCartOpen(prevState => !prevState);
    };

    return (
        <CartContext.Provider value={{ cart, handleAddToCart,handleRemoveFromCart,handleDeleteFromCart, loadingProductId,isCartOpen,setIsCartOpen,toggleCart }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
